import React from 'react';
import { useAppSelector } from '../../../../app/hooks';
import { useFirestoreConnect } from 'react-redux-firebase';
import ScenesDataGrid from './ScenesDataGrid';

export default function BatchedScenes() {
    useFirestoreConnect([
        {
            collection: 'ndvi-process-tracking',
            storeAs: 'scenes',
            orderBy: [['date_reported_str', 'desc']],
            where: ['is_batched', '==', true],
        },
    ]);
    const scenes = useAppSelector((state) => (state.firestore as any).data?.scenes);

    return <ScenesDataGrid scenes={scenes} enableSelection={false} />;
}
